import { useEffect, useState } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import ModeStandby from '@mui/icons-material/ModeStandby';
import { CloverLogo, SquareLogo, StripeLogo, LightspeedLogo } from '@lendica/components';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
import { DataConnection } from '@lendica/utils';
import { useDataConnectionDataContext } from '../DataConnectionData';

const services = [
    {
        logo: SquareLogo,
        key: 'square',
    },
    {
        logo: StripeLogo,
        key: 'stripe',
    },
    {
        logo: LightspeedLogo,
        key: 'lightspeed',
    },
    // {
    //     logo: CloverLogo,
    //     key: 'clover'
    // },
];

export const PointOfSale = ({
    company_id,
    env,
    connections,
}: {
    company_id: string;
    env: string;
    connections?: DataConnection[];
}) => {
    const [expanded, setExpanded] = useState(false);
    const [connectedAccounts, setConnectedAccounts] = useState<string[]>([]);
    const [popupClosed, setPopupClosed] = useState(false);
    const [accountConnected, setAccountConnected] = useState(false);
    const { refreshConnections } = useDataConnectionDataContext();

    const launchPopup = (service: string) => {
        let win: any;
        let parameters = 'location=1,width=800,height=650';
        parameters += ',left=' + (screen.width - 800) / 2 + ',top=' + (screen.height - 650) / 2;

        setPopupClosed(false);
        // win = window.open(`http://localhost:5000/oauth/${service}?company_id=${company_id}`, 'connectPopup', parameters);
        // win = window.open(`https://micro-oauth-dev.herokuapp.com/oauth/${service}?company_id=${company_id}`, 'connectPopup', parameters);
        // win = window.open(`https://oauth.app.golendica.com/oauth/${service}?company_id=${company_id}`, 'connectPopup', parameters);

        if (env === 'idev') {
            win = window.open(
                `https://micro-oauth-dev.herokuapp.com/oauth/${service}?company_id=${company_id}`,
                'connectPopup',
                parameters
            );
        } else if (env === 'prod') {
            win = window.open(
                `https://oauth.app.golendica.com/oauth/${service}?company_id=${company_id}`,
                'connectPopup',
                parameters
            );
        }
        let interval = setInterval(() => {
            if (win.closed) {
                setPopupClosed(true);
                clearInterval(interval);
            }
        }, 1000);
    };

    useEffect(() => {
        const list = Array.isArray(connections) ? connections : [];
        const connected = services
            .filter(service => list.some((x: any) => x.active && x.saas_name === service.key))
            .map(service => service.key);

        setConnectedAccounts(connected);
        setAccountConnected(!!connected.length);
    }, [connections]);

    useEffect(() => {
        if (popupClosed) {
            refreshConnections();
        }
    }, [popupClosed, refreshConnections]);

    const handleClick = (service: string, isConnected: boolean) => {
        if (!isConnected) {
            launchPopup(service);
        }
    };

    return (
        <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
            sx={{
                '&:before': {
                    display: 'none',
                },
                'borderRadius': 1,
                'boxShadow': 'none',
                'paddingTop': 1,
                'background': '##EDEDF4',
                'border': '1px solid #EDEDF4',
                'mt': 1,
                'mb': 1,
                'paddingBottom': expanded ? 0 : 1,
            }}
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                color="#FFF"
                sx={{
                    border: 'none',
                    boxShadow: 'none',
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <ShoppingBagOutlinedIcon color="primary" />
                    <Typography fontWeight={500} ml={2} minWidth={150}>
                        Point of Sale
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        paddingX: '1rem',
                        alignItems: 'center',
                        width: '100%',
                    }}
                >
                    {accountConnected && <CheckCircleIcon color="success" />}
                </Box>
            </AccordionSummary>
            <AccordionDetails
                sx={{
                    padding: '0',
                }}
            >
                <Box>
                    {services.map((service, index) => {
                        const Logo = service.logo;
                        const isConnected = connectedAccounts.includes(service.key);

                        return (
                            <Box
                                key={index}
                                sx={{
                                    boxSizing: 'border-box',
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    padding: '1rem 1rem',
                                    background: '#f2f2f8',
                                    borderRadius: 1,
                                    marginY: 1,
                                    marginX: 2,
                                    cursor: 'pointer',
                                    height: 78,
                                }}
                                component="div"
                                onClick={() => handleClick(service.key, isConnected)}
                            >
                                <Logo />
                                {isConnected ? (
                                    <Box sx={{ display: 'flex' }}>
                                        <Typography mr={1}>connected</Typography>
                                        <ModeStandby color="success" />
                                    </Box>
                                ) : (
                                    <SyncAltIcon />
                                )}
                            </Box>
                        );
                    })}
                </Box>
            </AccordionDetails>
        </Accordion>
    );
};
